import React, {FC} from 'react';
import {Subject} from 'rxjs';
import styled from 'styled-components';

import {AppContentTypesEnum} from '../../libs/shared/core/src/store/panels/app/commonAppPanelState';
import {
  AppPanelId,
  makeComposerPanelId,
  makeInboxesPanelId,
} from '../../libs/shared/core/src/store/panels/panelStateBase';
import {SingleUseValue} from '../helpers/memoryHelpers';
import {AppBannersHost} from './app/banners/appBannersHost';
import {AppContentStandard} from './appContentStandard';
import {StandaloneComposerContainer} from './inboxes/composer/standaloneComposerContainer';
import {LegacyFrameRawBoot} from './legacy/legacyFrameHelpers';
import {VisitorExperienceV3} from './visitors/visitorExperienceV3';

/*
 * Props.
 */

interface AppContentProps {
  panelId: AppPanelId;
  contentType: AppContentTypesEnum;
  rawBoot$?: Subject<LegacyFrameRawBoot>;
  initialRawBoot?: SingleUseValue<unknown>;
}

/*
 * Styles.
 */

const StyledAppBannersHost = styled(AppBannersHost)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

/*
 * Component.
 */

export const AppContent: FC<AppContentProps> = (props) => {
  const {panelId, contentType} = props;

  switch (contentType) {
    case AppContentTypesEnum.STANDALONE_COMPOSER:
      return <StandaloneComposerContainer panelId={makeComposerPanelId(panelId)} />;

    case AppContentTypesEnum.VISITOR_EXPERIENCE_V3:
      return (
        <>
          <VisitorExperienceV3 panelId={makeInboxesPanelId(panelId)} />
          <StyledAppBannersHost panelId={panelId} />
        </>
      );

    default: {
      return (
        <AppContentStandard
          panelId={panelId}
          contentType={contentType}
          rawBoot$={props.rawBoot$}
          initialRawBoot={props.initialRawBoot}
        />
      );
    }
  }
};
